/* eslint-disable react/prop-types */
import { AbsoluteCenter, Box, Divider, GridItem } from "@chakra-ui/react";
import React from "react";

const SectionDivider = ({ key, message, colSpan = 3 }) => {
  return (
    <GridItem colSpan={colSpan} id={message} mt={1}>
      <Box position="relative">
        <Divider borderWidth="thin" borderColor="bgColor" />
        <AbsoluteCenter
          bg="white"
          px={{ base: 1, md: 3 }}
          fontSize={{ base: "sm", md: "lg" }}
          fontWeight={500}
          color="black"
        >
          {message}
        </AbsoluteCenter>
      </Box>
    </GridItem>
  );
};

export default SectionDivider;
